import { memo } from '../../lib/teact/teact';

import buildClassName from '../../util/buildClassName';
import {
  closeCrmView,
  type CrmTab,
  getActiveCrmTab,
  getIsCrmViewOpen,
  openCrmTab,
} from '../../services/crmViewsState';

import useDerivedState from '../../hooks/useDerivedState';
import useLastCallback from '../../hooks/useLastCallback';

import ChannelBroadcastView from './ChannelBroadcastView';
import KnowledgeBaseView from './KnowledgeBaseView';
import ProtocolsView from './ProtocolsView';
import SystemSettingsView from './SystemSettingsView';

import styles from './CrmContainer.module.scss';

const TABS: { id: CrmTab; label: string; icon: string }[] = [
  { id: 'knowledge', label: 'Base de Conocimiento RAG', icon: '📚' },
  { id: 'broadcast', label: 'Diseñador de Anuncios', icon: '📢' },
  { id: 'protocols', label: 'Protocolos de Atención', icon: '📋' },
  { id: 'settings', label: 'Configuración Sistema', icon: '⚙️' },
];

const CrmContainer = () => {
  const isOpen = useDerivedState(getIsCrmViewOpen);
  const activeTab = useDerivedState(getActiveCrmTab);

  const handleTabClick = useLastCallback((tab: CrmTab) => {
    openCrmTab(tab);
  });

  const getTitle = () => {
    switch (activeTab) {
      case 'knowledge': return 'Base de Conocimiento RAG';
      case 'broadcast': return 'Diseñador de Anuncios (Canal)';
      case 'protocols': return 'Protocolos de Atención (Playbooks)';
      case 'settings': return 'Configuración Institucional';
      default: return 'TelegramAI CRM Suite';
    }
  };

  return (
    <div className={buildClassName(styles.root, isOpen && styles.isOpen)}>
      {/* Top Header Bar */}
      <header className={styles.topBar}>
        <div className={styles.leftGroup}>
          <button
            type="button"
            className={styles.backButton}
            onClick={closeCrmView}
            aria-label="Volver a la mensajería"
          >
            ←
          </button>
          <h2 className={styles.title}>{getTitle()}</h2>
        </div>
        <div>
          <span className={styles.titleBadge}>
            EGEMC POSGRADO UMSS
          </span>
        </div>
      </header>

      {/* Tabs Selector */}
      <nav className={styles.tabsBar}>
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={buildClassName(styles.tabButton, activeTab === tab.id && styles.active)}
            onClick={() => handleTabClick(tab.id)}
          >
            <span>{tab.icon}</span>
            <span>{tab.label}</span>
          </button>
        ))}
      </nav>

      {/* Content Area */}
      <main className={styles.contentArea}>
        {activeTab === 'knowledge' && <KnowledgeBaseView />}
        {activeTab === 'broadcast' && <ChannelBroadcastView />}
        {activeTab === 'protocols' && <ProtocolsView />}
        {activeTab === 'settings' && <SystemSettingsView />}
      </main>
    </div>
  );
};

export default memo(CrmContainer);
